var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog204(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_204",
    "data-name": 204,
    className: "cls-2",
    d: "M80.27,3.18c-3.6-4-17.95,3.72-22.37,6.1A76.92,76.92,0,0,0,30.35,34.56c-6.8,10.25-14.22,25.18-11.09,37.76C23.36,88.78,43,101.14,51.8,96.72c8.56-4.3-.19-20.93,8.13-48.8C67.89,21.25,84.44,7.8,80.27,3.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog204);
export default __webpack_public_path__ + "static/media/dog_204.263214b45230f16e7a847c7fd8760e12.svg";
export { ForwardRef as ReactComponent };